import React from "react";

const Hero = () => {
  return (
    <div class="bg-lemongreen max-h-96 p-10 flex flex-row flex-1 justify-center">
      <div class="md:mx-20 flex flex-col justify-end items-start max-w-xl mx-5">
        <h1 class="font-markazi text-lemonyellow text-3xl sm:text-5xl lg:text-6xl font-medium -mb-3">
          Little Lemon
        </h1>
        <h2 class="font-markazi text-lemongray text-lg sm:text-3xl lg:text-4xl font-normal mb-6">
          Chicago
        </h2>
        <p class="font-karla text-lemongray text-xs sm:text-base font-light mb-10 lg:pr-28 max-w-md">
          We are a family owned Mediterranean restaurant focused on traditional
          recipes served with a modern twist.
        </p>
        <a href="/reservations">
          <button class="lemonbutton">Reserve A Table</button>
        </a>
      </div>
      <div class="w-[100vw] md:w-5/6 md:h-96 overflow-hidden rounded-2xl relative drop-shadow-xl shadow-md max-w-xl justify-start ml-2">
        <img
          src="restauranfood.jpg"
          alt="Food on a serving tray"
          class="absolute object-center object-cover w-full h-full"
        />
      </div>
    </div>
  );
};

export default Hero;
